<template>
  <div class="page-header header-filter">
    <div class="page-header-image spacecraft-background" 
    :style="`background-image: url('/img/missions/${$route.params.missionId}-Primaria.png')`"/>

    <div class="container spacecraft-container-glass">
      <div class="mission-screen pr-4">
        <div class="row">
          <div class="row between w-100">
            <div class="col text-left">
              <n-button
                type="primary"
                size="lg"
                round
                @click="goToMission()"
                label="Regresar"
                icon-left="fas fa-arrow-left"
              />
            </div>
            <div class="col mt-2">
              <h2>
                <router-link to="/">
                  <img src="/img/icons/favicon-white.png" width="10%"/>
                </router-link>
                Tests
              </h2>
            </div>
            <div class="col text-right">
              <n-button
                type="primary"
                size="lg"
                round
                @click="logout()"
                label="Cerrar sesión"
                icon-right="fas fa-sign-out-alt"
              />
            </div>
          </div>
          <tabs type="primary">
            <tab-pane label="Fracciones">

              <h2 class="text-primary">Fracciones</h2>
              <hr>
              <h3 class="text-primary">
                <i class="fas fa-wrench"></i>
                Propiedades
              </h3>

              <table class="table table-dark">
                <thead>
                  <th>
                    Nombre
                  </th>
                  <th>
                    Tipo
                  </th>
                  <th>
                    Default
                  </th>
                  <th>
                    Descripción
                  </th>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      instructions
                    </td>
                    <td>
                      String
                    </td>
                    <td>
                      Rellena los campos en blanco para hacer coincidir las fracciones.
                    </td>
                    <td>
                      Son intrucciones para mostrar al usuario y ayudar a entender el ejercicio.
                    </td>
                  </tr>
                  <tr>
                    <td style="word-wrap: break-word;">
                      fractions
                    </td>
                    <td>
                      Array
                    </td>
                    <td>
                      <code>
                        {{JSON.stringify([{
                        numerator: '',
                        numeratorDisabled: false,
                        denominator: '',
                        denominatorDisabled: false,
                        correctNumerator: '',
                        correctDenominator: ''
                      },
                      {
                        numerator: '',
                        numeratorDisabled: false,
                        denominator: '',
                        denominatorDisabled: false,
                        correctNumerator: '',
                        correctDenominator: ''
                      }])}}
                      </code>
                    </td>
                    <td>
                      Define las fracciones a comparar y sus valores iniciales.
                      <br>
                      <code>numerator</code>: Define el valor inicial del numerador, si es un string vacio aparece en blanco.
                      <br>
                      <code>numeratorDisabled</code>: Define si el numerador debe estar deshabilitado para el usuario.
                      <br>
                      <code>denominator</code>: Define el valor inicial del denominador, si es un string vacio aparece en blanco.
                      <br>
                      <code>denominatorDisabled</code>: Define si el denominador debe estar deshabilitado para el usuario.
                      <br>
                      <code>correctNumerator</code>: Define el valor correcto para el numerador, se muestra al finalizar si hay errores en las respuestas.
                      <br>
                      <code>correctDenominator</code>: Define el valor correcto para el denominador, se muestra al finalizar si hay errores en las respuestas.
                    </td>
                  </tr>
                  <tr>
                    <td style="word-wrap: break-word;">
                      showStrip
                    </td>
                    <td>
                      Boolean
                    </td>
                    <td>
                      true
                    </td>
                    <td>
                      Define si se debe mostrar la regleta de apoyo, cuando sea <code>true</code> se mostrará, y cuando sea <code>false</code> se mantendrá oculta.
                    </td>
                  </tr>
                  <tr>
                    <td style="word-wrap: break-word;">
                      maxAttempts
                    </td>
                    <td>
                      Number
                    </td>
                    <td>
                      0
                    </td>
                    <td>
                      Define un número máximo de intentos, por defecto su valor es 0 por lo que no tiene un limite.
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 class="text-primary">
                <i class="fas fa-cogs"></i>
                Eventos
              </h3>

              <table class="table table-dark">
                <thead>
                  <th>
                    Nombre
                  </th>
                  <th>
                    Propiedades
                  </th>
                  <th>
                    Descripción
                  </th>
                </thead>
                <tbody>
                  <td>
                    evaluated
                  </td>
                  <td>
                    <code>value</code>: Resultado de la evaluación (Boolean).
                    <br>
                    <code>fractions</code>: Fracciones ingresadas al momento de evaluar (Array).
                  </td>
                  <td>
                    El evento se emite una vez que el usuario llena todos los campos y 
                    ejecuta la evaluación para ver si sus respuestas son correctas.
                  </td>
                </tbody>
              </table>

              <h3 class="text-primary">Demo con propiedades default, respuestas libres</h3>

              <highlightjs style="atom-one-dark" language='html' code="<fractions/>"/>

              <div class="row w-100">
                <fractions/>
              </div>

              <h3 class="text-primary">Demo con tres números</h3>

              <div class="row w-100">
                <fractions
                  instructions='Otras instrucciones para el alumno, escribe dos fracciones iguales'
                  :maxAttempts= '3'
                  :fractions="[{
                    numerator: '2',
                    correctNumerator: '2',
                    numeratorDisabled: false,
                    denominator: '8',
                    correctDenominator: '8',
                    denominatorDisabled: false
                  },
                  {
                    numerator: '',
                    correctNumerator: '1',
                    numeratorDisabled: false,
                    denominator: '4',
                    correctDenominator: '4',
                    denominatorDisabled: true
                  }]"
                />
              </div>

              <h3 class="text-primary"
              +              />

              <div class="row w-100">
                <fractions
                  instructions='Otras instrucciones para el alumno, escribe dos fracciones iguales'
                  :maxAttempts= '3'
                  :fractions="[{
                    numerator: '1',
                    correctNumerator: '1',
                    numeratorDisabled: false,
                    denominator: '',
                    correctDenominator: '5',
                    denominatorDisabled: false
                  },
                  {
                    numerator: '',
                    correctNumerator: '2',
                    numeratorDisabled: false,
                    denominator: '10',
                    correctDenominator: '10',
                    denominatorDisabled: true
                  }]"
                  :showStrip="false"
                />
              </div>
            </tab-pane>

            <!--<tab-pane label="Regleta">

              <h2 class="text-primary">Regleta</h2>
              <hr>
              <h3 class="text-primary">
                <i class="fas fa-wrench"></i>
                Propiedades
              </h3>

              <table class="table table-dark">
                <thead>
                  <th>
                    Nombre
                  </th>
                  <th>
                    Tipo
                  </th>
                  <th>
                    Default
                  </th>
                  <th>
                    Descripción
                  </th>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      instructions
                    </td>
                    <td>
                      String
                    </td>
                    <td>
                      Ingresa un número máximo de filas y un denominador para crear la regleta y buscar coincidencias.
                    </td>
                    <td>
                      Son intrucciones para mostrar al usuario y ayudar a entender el ejercicio.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      rows
                    </td>
                    <td>
                      Number
                    </td>
                    <td>
                      10
                    </td>
                    <td>
                      Número de filas a mostrar en la regleta
                    </td>
                  </tr>
                  <tr>
                    <td>
                      denominator
                    </td>
                    <td>
                      Number
                    </td>
                    <td>
                      1
                    </td>
                    <td>
                      Denominador inicial para crear regleta
                    </td>
                  </tr>
                  <tr>
                    <td>
                      autoinit
                    </td>
                    <td>
                      Boolean
                    </td>
                    <td>
                      false
                    </td>
                    <td>
                      Define si la regleta debería autocrearse con la configuración inical.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      clickable
                    </td>
                    <td>
                      Boolean
                    </td>
                    <td>
                      true
                    </td>
                    <td>
                      Define si se permite el click en la regleta para ver coincidencias.
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 class="text-primary">Demo con propiedades default</h3>

              <highlightjs style="atom-one-dark" language='html' code="<fractions-strip/>"/>

              <div class="row w-100">
                <fractions-strip/>
              </div>

              <h3 class="text-primary">Demo con propiedades configuradas</h3>

              <highlightjs style="atom-one-dark" language='html' code="<fractions-strip :rows='15' :denominator='2' :autoinit='true' :clickable='false'/>"/>

              <div class="row w-100">
                <fractions-strip :rows="15" :denominator="2" :autoinit="true" :clickable="false"/>
              </div>

            </tab-pane>

            <tab-pane label="Lectura automática por palabras">

              <h2 class="text-primary">Lectura automática por palabras</h2>
              <hr>
              <h3 class="text-primary">
                <i class="fas fa-wrench"></i>
                Propiedades
              </h3>

              <table class="table table-dark">
                <thead>
                  <th>
                    Nombre
                  </th>
                  <th>
                    Tipo
                  </th>
                  <th>
                    Default
                  </th>
                  <th>
                    Descripción
                  </th>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      instructions
                    </td>
                    <td>
                      String
                    </td>
                    <td>
                      Cuando estés listo da clic en "Comenzar" y realiza la lectura, al final 
                      sabras que tan rápido has leído.
                    </td>
                    <td>
                      Son intrucciones para mostrar al usuario y ayudar a entender el ejercicio.
                    </td>
                  </tr>
                  <tr>
                    <td style="word-wrap: break-word;">
                      text
                    </td>
                    <td>
                      String
                    </td>
                    <td class="text-secondary">
                      Ninguno
                    </td>
                    <td>
                      Es el texto que se mostrará al usuario para su lectura.
                    </td>
                  </tr>
                  <tr>
                    <td style="word-wrap: break-word;">
                      timerPerWord
                    </td>
                    <td>
                      Number
                    </td>
                    <td>
                      1
                    </td>
                    <td>
                      Es la duración en <b>segundos</b> que debé durar cada palabra en pantalla. El valor debé un ser un número mayor a <code>0</code>.
                    </td>
                  </tr>
                  <tr>
                    <td style="word-wrap: break-word;">
                      numberOfWords
                    </td>
                    <td>
                      Number
                    </td>
                    <td>
                      1
                    </td>
                    <td>
                      Es la cantidad de palabras que se mostrarán al usuario al mismo tiempo, los 
                      valores pueden ser <code>1</code>, <code>2</code> o <code>3</code>. 
                      Cuando el valor sea <code>2</code> se mostrará la palabra actual y la siguiente, 
                      si el valor es <code>3</code> se mostrará la palabra actual, la anterior y la siguiente.
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 class="text-primary">Demo con propiedades default</h3>

              <highlightjs
                style="atom-one-dark"
                language='html'
                code="
<reading-per-words
  text='La primera fotografía que se tomó en México fue obra del francés Jean 
  Prelier Dudoille. Prelier fotografió el Puerto de Veracruz al llegar a México el 3 de diciembre de 1839. Pocos meses después, el mismo Prelier ya contaba 
  con un acervo fotográfico de México que incluía la Catedral Metropolitana, la Piedra del Sol y el Palacio de Minería.'
/>
                "
              />

              <div class="row w-100">
                <reading-per-words
                  text="La primera fotografía que se tomó en México fue obra del francés Jean Prelier Dudoille. Prelier fotografió el Puerto de Veracruz al llegar a México el 3 de diciembre de 1839. Pocos meses después, el mismo Prelier ya contaba con un acervo fotográfico de México que incluía la Catedral Metropolitana, la Piedra del Sol y el Palacio de Minería."
                />
              </div>

              <h3 class="text-primary">Demo con propiedades configuradas</h3>

              <highlightjs
                style="atom-one-dark"
                language='html'
                code="
<reading-per-words
  text='La primera fotografía que se tomó en México fue obra del francés Jean 
  Prelier Dudoille. Prelier fotografió el Puerto de Veracruz al llegar a México el 3 de diciembre de 1839. Pocos meses después, el mismo Prelier ya contaba 
  con un acervo fotográfico de México que incluía la Catedral Metropolitana, la Piedra del Sol y el Palacio de Minería.'
  instructions='Otras instrucciones.'
  :timerPerWord='0.5'
  :numberOfWords='3'
/>
                "
              />

              <div class="row w-100">
                <reading-per-words
                  text="La primera fotografía que se tomó en México fue obra del francés Jean Prelier Dudoille. Prelier fotografió el Puerto de Veracruz al llegar a México el 3 de diciembre de 1839. Pocos meses después, el mismo Prelier ya contaba con un acervo fotográfico de México que incluía la Catedral Metropolitana, la Piedra del Sol y el Palacio de Minería."
                  instructions="Otras instrucciones."
                  :timerPerWord="0.5"
                  :numberOfWords="3"
                />
              </div>

            </tab-pane>

            <tab-pane label="Lectura manual por palabras">

              <h2 class="text-primary">Lectura manual por palabras</h2>
              <hr>
              <h3 class="text-primary">
                <i class="fas fa-wrench"></i>
                Propiedades
              </h3>

              <table class="table table-dark">
                <thead>
                  <th>
                    Nombre
                  </th>
                  <th>
                    Tipo
                  </th>
                  <th>
                    Default
                  </th>
                  <th>
                    Descripción
                  </th>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      instructions
                    </td>
                    <td>
                      String
                    </td>
                    <td>
                      Cuando estés listo da clic en "Comenzar" y realiza la lectura, da clic en el recuadro de
                      texto o el botón de "Siguiente" para avanzar.
                    </td>
                    <td>
                      Son intrucciones para mostrar al usuario y ayudar a entender el ejercicio.
                    </td>
                  </tr>
                  <tr>
                    <td style="word-wrap: break-word;">
                      text
                    </td>
                    <td>
                      String
                    </td>
                    <td class="text-secondary">
                      Ninguno
                    </td>
                    <td>
                      Es el texto que se mostrará al usuario para su lectura.
                    </td>
                  </tr>
                  <tr>
                    <td style="word-wrap: break-word;">
                      timer
                    </td>
                    <td>
                      Number
                    </td>
                    <td class="text-secondary">
                      Ninguno
                    </td>
                    <td>
                      Es la duración máxima en <b>segundos</b> que el usuario tiene para terminar el ejercicio y es opcional . El valor debé un ser un número entero mayor a <code>1</code>.
                    </td>
                  </tr>
                  <tr>
                    <td style="word-wrap: break-word;">
                      numberOfWords
                    </td>
                    <td>
                      Number
                    </td>
                    <td>
                      1
                    </td>
                    <td>
                      Es la cantidad de palabras que se mostrarán al usuario al mismo tiempo, los 
                      valores pueden ser <code>1</code>, <code>2</code> o <code>3</code>. 
                      Cuando el valor sea <code>2</code> se mostrará la palabra actual y la siguiente, 
                      si el valor es <code>3</code> se mostrará la palabra actual, la anterior y la siguiente.
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 class="text-primary">Demo con propiedades default</h3>

              <highlightjs
                style="atom-one-dark"
                language='html'
                code="
<manual-reading-per-words
  text='La primera fotografía que se tomó en México fue obra del francés Jean 
  Prelier Dudoille. Prelier fotografió el Puerto de Veracruz al llegar a México el 3 de diciembre de 1839. Pocos meses después, el mismo Prelier ya contaba 
  con un acervo fotográfico de México que incluía la Catedral Metropolitana, la Piedra del Sol y el Palacio de Minería.'
/>
                "
              />

              <div class="row w-100">
                <manual-reading-per-words
                  text="La primera fotografía que se tomó en México fue obra del francés Jean Prelier Dudoille. Prelier fotografió el Puerto de Veracruz al llegar a México el 3 de diciembre de 1839. Pocos meses después, el mismo Prelier ya contaba con un acervo fotográfico de México que incluía la Catedral Metropolitana, la Piedra del Sol y el Palacio de Minería."
                />
              </div>

              <h3 class="text-primary">Demo con propiedades configuradas</h3>

              <highlightjs
                style="atom-one-dark"
                language='html'
                code="
<manual-reading-per-words
  text='La primera fotografía que se tomó en México fue obra del francés Jean 
  Prelier Dudoille. Prelier fotografió el Puerto de Veracruz al llegar a México el 3 de diciembre de 1839. Pocos meses después, el mismo Prelier ya contaba 
  con un acervo fotográfico de México que incluía la Catedral Metropolitana, la Piedra del Sol y el Palacio de Minería.'
  instructions='Otras instrucciones.'
  :timer='20'
  :numberOfWords='3'
/>
                "
              />

              <div class="row w-100">
                <manual-reading-per-words
                  text="La primera fotografía que se tomó en México fue obra del francés Jean Prelier Dudoille. Prelier fotografió el Puerto de Veracruz al llegar a México el 3 de diciembre de 1839. Pocos meses después, el mismo Prelier ya contaba con un acervo fotográfico de México que incluía la Catedral Metropolitana, la Piedra del Sol y el Palacio de Minería."
                  instructions="Otras instrucciones."
                  :timer='20'
                  :numberOfWords='3'
                />
              </div>

            </tab-pane>

            <tab-pane label="Lectura automática">

              <h2 class="text-primary">Lectura automática por palabras</h2>
              <hr>
              <h3 class="text-primary">
                <i class="fas fa-wrench"></i>
                Propiedades
              </h3>

              <table class="table table-dark">
                <thead>
                  <th>
                    Nombre
                  </th>
                  <th>
                    Tipo
                  </th>
                  <th>
                    Default
                  </th>
                  <th>
                    Descripción
                  </th>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      instructions
                    </td>
                    <td>
                      String
                    </td>
                    <td>
                      Cuando estés listo da clic en "Comenzar" y realiza la lectura conforme se subrayen
                      las palabras, al final sabras que tan rápido has leído.
                    </td>
                    <td>
                      Son intrucciones para mostrar al usuario y ayudar a entender el ejercicio.
                    </td>
                  </tr>
                  <tr>
                    <td style="word-wrap: break-word;">
                      text
                    </td>
                    <td>
                      String
                    </td>
                    <td class="text-secondary">
                      Ninguno
                    </td>
                    <td>
                      Es el texto que se mostrará al usuario para su lectura.
                    </td>
                  </tr>
                  <tr>
                    <td style="word-wrap: break-word;">
                      timerPerWord
                    </td>
                    <td>
                      Number
                    </td>
                    <td>
                      1
                    </td>
                    <td>
                      Es la duración en <b>segundos</b> que debe tardar cada palabra antes de subrayar la siguiente. El valor debé un ser un número entero mayor a <code>1</code>.
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 class="text-primary">Demo con propiedades default</h3>

              <highlightjs
                style="atom-one-dark"
                language='html'
                code="
<automatic-reading
  text='La primera fotografía que se tomó en México fue obra del francés Jean 
  Prelier Dudoille. Prelier fotografió el Puerto de Veracruz al llegar a México el 3 de diciembre de 1839. Pocos meses después, el mismo Prelier ya contaba 
  con un acervo fotográfico de México que incluía la Catedral Metropolitana, la Piedra del Sol y el Palacio de Minería.'
/>
                "
              />

              <div class="row w-100">
                <automatic-reading
                  text="La primera fotografía que se tomó en México fue obra del francés Jean Prelier Dudoille. Prelier fotografió el Puerto de Veracruz al llegar a México el 3 de diciembre de 1839. Pocos meses después, el mismo Prelier ya contaba con un acervo fotográfico de México que incluía la Catedral Metropolitana, la Piedra del Sol y el Palacio de Minería."
                />
              </div>

              <h3 class="text-primary">Demo con propiedades configuradas</h3>

              <highlightjs
                style="atom-one-dark"
                language='html'
                code="
<automatic-reading
  text='La primera fotografía que se tomó en México fue obra del francés Jean 
  Prelier Dudoille. Prelier fotografió el Puerto de Veracruz al llegar a México el 3 de diciembre de 1839. Pocos meses después, el mismo Prelier ya contaba 
  con un acervo fotográfico de México que incluía la Catedral Metropolitana, la Piedra del Sol y el Palacio de Minería.'
  instructions='Otras instrucciones.'
  :timerPerWord='3'
/>
                "
              />

              <div class="row w-100">
                <automatic-reading
                  text="La primera fotografía que se tomó en México fue obra del francés Jean Prelier Dudoille. Prelier fotografió el Puerto de Veracruz al llegar a México el 3 de diciembre de 1839. Pocos meses después, el mismo Prelier ya contaba con un acervo fotográfico de México que incluía la Catedral Metropolitana, la Piedra del Sol y el Palacio de Minería."
                  instructions="Otras instrucciones."
                  :timerPerWord='3'
                />
              </div>

            </tab-pane>

            <tab-pane label="Sinónimos">

              <h2 class="text-primary">Sinónimos</h2>
              <hr>
              <h3 class="text-primary">
                <i class="fas fa-wrench"></i>
                Propiedades
              </h3>

              <table class="table table-dark">
                <thead>
                  <th>
                    Nombre
                  </th>
                  <th>
                    Tipo
                  </th>
                  <th>
                    Default
                  </th>
                  <th>
                    Descripción
                  </th>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      instructions
                    </td>
                    <td>
                      String
                    </td>
                    <td>
                      Cuando estés listo da clic en "Comenzar" y realiza la lectura conforme se subrayen
                      las palabras, al final sabras que tan rápido has leído.
                    </td>
                    <td>
                      Son intrucciones para mostrar al usuario y ayudar a entender el ejercicio.
                    </td>
                  </tr>
                  <tr>
                    <td style="word-wrap: break-word;">
                      text
                    </td>
                    <td>
                      String
                    </td>
                    <td class="text-secondary">
                      Ninguno
                    </td>
                    <td>
                      Es el texto que se mostrará al usuario para su lectura.
                    </td>
                  </tr>
                  <tr>
                    <td style="word-wrap: break-word;">
                      synonyms
                    </td>
                    <td>
                      Array
                    </td>
                    <td class="text-secondary">
                      Ninguno
                    </td>
                    <td>
                      Es un arreglo de objetos donde cada objeto contiene la palabra a evaluar y
                      otro objeto que contiene las opciones de sinónimos.
                      <br>
                      <code>keyWord</code>: String que define la palabra principal para elegirle un sinómimo.
                      <br>
                      <code>options</code>: Array de objetos que define las opciones para elegir.
                      <br>
                      <div class="ml-4">
                        <code>word</code>:  String que define la palabra a mostrar como opción.
                        <br>
                        <code>isSynonymous</code>: Boolean que define si la opción es un sinómimo de la palabra principal (<code>keyWord</code>),
                        cuando sea <code>true</code> se toma como una opción correcta,
                        y cuando sea <code>false</code> se toma como incorrecta.
                        <br>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style="word-wrap: break-word;">
                      showResults
                    </td>
                    <td>
                      Boolean
                    </td>
                    <td>
                      false
                    </td>
                    <td>
                      Define si se debe mostrar el resultado de cada respuesta, cuando sea <code>true</code> se mostrará durante la ejecución del ejercicio,
                      y cuando sea <code>false</code> se mantendrá solo al terminarlo.
                    </td>
                  </tr>
                  <tr>
                    <td style="word-wrap: break-word;">
                      showAnswers
                    </td>
                    <td>
                      Boolean
                    </td>
                    <td>
                      true
                    </td>
                    <td>
                      Define si se debe mostrar una tabla con las respuetas seleccionadas y las respuestas correctas al terminar el ejercicio,
                      cuando sea <code>true</code> se mostrará,
                      y cuando sea <code>false</code> se mantendrá oculto.
                    </td>
                  </tr>
                  <tr>
                    <td style="word-wrap: break-word;">
                      maxAttempts
                    </td>
                    <td>
                      Number
                    </td>
                    <td>
                      0
                    </td>
                    <td>
                      Define un número máximo de intentos, por defecto su valor es 0 por lo que no tiene un limite.
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 class="text-primary">Demo con propiedades default</h3>

              <highlightjs
                style="atom-one-dark"
                language='html'
                code="
<synonyms
  text='La primera fotografía que se tomó en México fue obra del francés Jean 
  Prelier Dudoille. Prelier fotografió el Puerto de Veracruz al llegar a México el 3 de diciembre de 1839. Pocos meses después, el mismo Prelier ya contaba 
  con un acervo fotográfico de México que incluía la Catedral Metropolitana, la Piedra del Sol y el Palacio de Minería.'
  :maxAttempts='3'
  :showResults='true',
  :showAnswers='true',
  :synonyms='[{
    keyWord: 'obra',
    options: [
      {
        word: 'producto',
        isSynonymous: true
      },
      {
        word: 'atraido',
        isSynonymous: false
      },
      {
        word: 'creación',
        isSynonymous: true
      },
      {
        word: 'imagen',
        isSynonymous: false
      }
    ]
  },
  {
    keyWord: 'llegar',
    options: [
      {
        word: 'arrivar',
        isSynonymous: true
      },
      {
        word: 'despedir',
        isSynonymous: false
      },
      {
        word: 'comenzar',
        isSynonymous: false
      },
      {
        word: 'caminar',
        isSynonymous: false
      }
    ]
  },
  {
    keyWord: 'incluía',
    options: [
      {
        word: 'incoporaba',
        isSynonymous: true
      },
      {
        word: 'excluía',
        isSynonymous: false
      },
      {
        word: 'arreglaba',
        isSynonymous: false
      },
      {
        word: 'mejoraba',
        isSynonymous: false
      }
    ]
  }]'
/>
                "
              />

              <div class="row w-100">
                <synonyms
                  text="La primera fotografía que se tomó en México fue obra del francés Jean Prelier Dudoille. Prelier fotografió el Puerto de Veracruz al llegar a México el 3 de diciembre de 1839. Pocos meses después, el mismo Prelier ya contaba con un acervo fotográfico de México que incluía la Catedral Metropolitana, la Piedra del Sol y el Palacio de Minería."
                  :maxAttempts="3"
                  :showResults="true"
                  :showAnswers="true"
                  :synonyms="[{
                    keyWord: 'obra',
                    options: [
                      {
                        word: 'producto',
                        isSynonymous: true
                      },
                      {
                        word: 'atraido',
                        isSynonymous: false
                      },
                      {
                        word: 'creación',
                        isSynonymous: true
                      },
                      {
                        word: 'imagen',
                        isSynonymous: false
                      }
                    ]
                  },
                  {
                    keyWord: 'llegar',
                    options: [
                      {
                        word: 'arrivar',
                        isSynonymous: true
                      },
                      {
                        word: 'despedir',
                        isSynonymous: false
                      },
                      {
                        word: 'comenzar',
                        isSynonymous: false
                      },
                      {
                        word: 'caminar',
                        isSynonymous: false
                      }
                    ]
                  },
                  {
                    keyWord: 'incluía',
                    options: [
                      {
                        word: 'incorporaba',
                        isSynonymous: true
                      },
                      {
                        word: 'excluía',
                        isSynonymous: false
                      },
                      {
                        word: 'arreglaba',
                        isSynonymous: false
                      },
                      {
                        word: 'mejoraba',
                        isSynonymous: false
                      }
                    ]
                  }]"
                />
              </div>

              <h3 class="text-primary">Demo con propiedades configuradas</h3>

              <highlightjs
                style="atom-one-dark"
                language='html'
                code="
<synonyms
  text='La primera fotografía que se tomó en México fue obra del francés Jean 
  Prelier Dudoille. Prelier fotografió el Puerto de Veracruz al llegar a México el 3 de diciembre de 1839. Pocos meses después, el mismo Prelier ya contaba 
  con un acervo fotográfico de México que incluía la Catedral Metropolitana, la Piedra del Sol y el Palacio de Minería.'
  instructions='Otras instrucciones.'
  :synonyms='[{
    keyWord: 'obra',
    options: [
      {
        word: 'producto',
        isSynonymous: true
      },
      {
        word: 'atraido',
        isSynonymous: false
      },
      {
        word: 'creación',
        isSynonymous: true
      },
      {
        word: 'imagen',
        isSynonymous: false
      }
    ]
  },
  {
    keyWord: 'llegar',
    options: [
      {
        word: 'arrivar',
        isSynonymous: true
      },
      {
        word: 'despedir',
        isSynonymous: false
      },
      {
        word: 'comenzar',
        isSynonymous: false
      },
      {
        word: 'caminar',
        isSynonymous: false
      }
    ]
  },
  {
    keyWord: 'incluía',
    options: [
      {
        word: 'incorporaba',
        isSynonymous: true
      },
      {
        word: 'excluía',
        isSynonymous: false
      },
      {
        word: 'arreglaba',
        isSynonymous: false
      },
      {
        word: 'mejoraba',
        isSynonymous: false
      }
    ]
  }]'
/>
                "
              />

              <div class="row w-100">
                <synonyms
                  text="La primera fotografía que se tomó en México fue obra del francés Jean Prelier Dudoille. Prelier fotografió el Puerto de Veracruz al llegar a México el 3 de diciembre de 1839. Pocos meses después, el mismo Prelier ya contaba con un acervo fotográfico de México que incluía la Catedral Metropolitana, la Piedra del Sol y el Palacio de Minería."
                  instructions="Otras instrucciones."
                  :synonyms="[{
                    keyWord: 'obra',
                    options: [
                      {
                        word: 'producto',
                        isSynonymous: true
                      },
                      {
                        word: 'atraido',
                        isSynonymous: false
                      },
                      {
                        word: 'creación',
                        isSynonymous: true
                      },
                      {
                        word: 'imagen',
                        isSynonymous: false
                      }
                    ]
                  },
                  {
                    keyWord: 'llegar',
                    options: [
                      {
                        word: 'arrivar',
                        isSynonymous: true
                      },
                      {
                        word: 'despedir',
                        isSynonymous: false
                      },
                      {
                        word: 'comenzar',
                        isSynonymous: false
                      },
                      {
                        word: 'caminar',
                        isSynonymous: false
                      }
                    ]
                  },
                  {
                    keyWord: 'incluía',
                    options: [
                      {
                        word: 'incorporaba',
                        isSynonymous: true
                      },
                      {
                        word: 'excluía',
                        isSynonymous: false
                      },
                      {
                        word: 'arreglaba',
                        isSynonymous: false
                      },
                      {
                        word: 'mejoraba',
                        isSynonymous: false
                      }
                    ]
                  }]"
                />
              </div>

            </tab-pane>

            <tab-pane label="Cuestionario">

              <h2 class="text-primary">Cuestionario</h2>
              <hr>
              <h3 class="text-primary">
                <i class="fas fa-wrench"></i>
                Propiedades
              </h3>

              <table class="table table-dark">
                <thead>
                  <th>
                    Nombre
                  </th>
                  <th>
                    Tipo
                  </th>
                  <th>
                    Default
                  </th>
                  <th>
                    Descripción
                  </th>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      instructions
                    </td>
                    <td>
                      String
                    </td>
                    <td>
                      Responde las siguientes preguntas.
                    </td>
                    <td>
                      Son intrucciones para mostrar al usuario y ayudar a entender el ejercicio.
                    </td>
                  </tr>
                  <tr>
                    <td style="word-wrap: break-word;">
                      text
                    </td>
                    <td>
                      String
                    </td>
                    <td class="text-secondary">
                      Ninguno
                    </td>
                    <td>
                      Es el texto que se mostrará al usuario para su lectura.
                    </td>
                  </tr>
                  <tr>
                    <td style="word-wrap: break-word;">
                      title
                    </td>
                    <td>
                      String
                    </td>
                    <td class="text-secondary">
                      Ninguno
                    </td>
                    <td>
                      Es el título del cuestionario.
                    </td>
                  </tr>
                  <tr>
                    <td style="word-wrap: break-word;">
                      image
                    </td>
                    <td>
                      String
                    </td>
                    <td class="text-secondary">
                      Ninguno
                    </td>
                    <td>
                      Es la URL de la imagen a mostrar.
                    </td>
                  </tr>
                  <tr>
                    <td style="word-wrap: break-word;">
                      questions
                    </td>
                    <td>
                      Array
                    </td>
                    <td class="text-secondary">
                      Ninguno
                    </td>
                    <td>
                      Es un arreglo de objetos, donde cada objeto contiene la pregunta a evaluar y
                      otro array de objetos que contiene las opciones para responder, correctar e incorrectas.
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 class="text-primary">Demo</h3>

              <highlightjs
                style="atom-one-dark"
                language='html'
                code="
<quiz
  text='La suma es la operación matemática de composición que consiste en combinar o añadir dos números o más para obtener una cantidad final o total.
  La suma también ilustra el proceso de juntar dos colecciones de objetos con el fin de obtener una sola colección. Por otro lado, la acción repetitiva
  de sumar uno, es la forma más básica de contar.'
  title='Matemáticas'
  instructions='Responde las siguientes preguntas.'
  image='https://cdn5.dibujos.net/dibujos/pintados/201305/12=3-colegio-pintado-por-nayelhis-9799343.jpg'
  :questions='[{
    question: 'Elige si la afirmación es verdadera o falsa',
    questionText: 'La prioridad de las operaciones refiere al conjunto de convenciones que regulan el orden en que una calculadora o un sistema evaluará
    una operación en una expresión combinada, que contenga dos o más operadores.',
    questionImage: '',
    isMultipleAnswer: false,
    options: [
      {
        option: 'Verdadero',
        optionImage: '',
        optionValue: true,
        isCorrect: true
      },
      {
        option: 'Falso',
        optionImage: '',
        optionValue: false,
        isCorrect: false
      }
    ]
  },
  {
    question: 'Revisa la imagen y responde, cuantos autos ves.',
    questionText: '',
    questionImage: 'https://st2.depositphotos.com/2366719/7101/v/950/depositphotos_71017355-stock-illustration-simple-cars.jpg',
    isMultipleAnswer: false,
    options: [
      {
        option: 'Hay menos de 10',
        optionImage: '',
        isCorrect: false
      },
      {
        option: 'Hay más de 10 y menos de 15',
        optionImage: '',
        isCorrect: false
      },
      {
        option: 'Hay menos de 20 y más de 10',
        optionImage: '',
        isCorrect: true
      }
    ]
  },
  {
    question: 'Lee el texto y selecciona las afirmaciones verdaderas.',
    questionText: 'Las matemáticas o la matemática​ es una ciencia formal que, partiendo de axiomas y siguiendo el razonamiento lógico, estudia las propiedades,
    estructuras abstractas y relaciones entre entidades abstractas como números, figuras geométricas, iconos, glifos, o símbolos en general.',
    questionImage: 'https://ichef.bbci.co.uk/news/800/cpsprodpb/164EE/production/_109347319_gettyimages-611195980.jpg',
    isMultipleAnswer: true,
    options: [
      {
        option: 'Las matemáticas son una ciencia',
        optionImage: '',
        isCorrect: true
      },
      {
        option: 'La matemática estudia los números',
        optionImage: '',
        isCorrect: true
      },
      {
        option: 'La matemática estudia las sustancias',
        optionImage: '',
        isCorrect: false
      }
    ]
  },
  {
    question: 'Selecciona la afirmacion verdadera.',
    questionText: '',
    questionImage: '',
    isMultipleAnswer: false,
    options: [
      {
        option: 'Las matemáticas son una ciencia',
        optionImage: '',
        isCorrect: true
      },
      {
        option: 'La matemática estudia los números',
        optionImage: '',
        isCorrect: true
      },
      {
        option: 'La matemática estudia las figuras geométricas',
        optionImage: '',
        isCorrect: true
      },
      {
        option: 'Todas las anteriores',
        optionImage: '',
        isCorrect: true
      }
    ]
  },{
    question: 'Selecciona la afirmacion verdadera.',
    questionText: '',
    questionImage: '',
    isMultipleAnswer: false,
    options: [
      {
        option: 'Las matemáticas son un invento',
        optionImage: '',
        isCorrect: false
      },
      {
        option: 'La matemática estudia los animales',
        optionImage: '',
        isCorrect: false
      },
      {
        option: 'La matemática estudia la biología',
        optionImage: '',
        isCorrect: false
      },
      {
        option: 'Ninguna de las anteriores',
        optionImage: '',
        isCorrect: true
      }
    ]
  }]'
/>
                "
              />
              <div class="row w-100">
                <quiz
                  text='La suma es la operación matemática de composición que consiste en combinar o añadir dos números o más para obtener una cantidad
                  final o total. La suma también ilustra el proceso de juntar dos colecciones de objetos con el fin de obtener una sola colección. Por otro lado,
                  la acción repetitiva de sumar uno, es la forma más básica de contar.'
                  title='Matemáticas'
                  instructions='Responde las siguientes preguntas.'
                  image='https://cdn5.dibujos.net/dibujos/pintados/201305/12=3-colegio-pintado-por-nayelhis-9799343.jpg'
                  :questions="[{
                    question: 'Elige si la afirmación es verdadera o falsa',
                    questionText: 'La prioridad de las operaciones refiere al conjunto de convenciones que regulan el orden en que una calculadora o un sistema evaluará una operación en una expresión combinada, que contenga dos o más operadores.',
                    questionImage: '',
                    isMultipleAnswer: false,
                    options: [
                      {
                        option: 'Verdadero',
                        optionImage: '',
                        optionValue: true,
                        isCorrect: true
                      },
                      {
                        option: 'Falso',
                        optionImage: '',
                        optionValue: false,
                        isCorrect: false
                      }
                    ]
                  },
                  {
                    question: 'Revisa la imagen y responde, cuantos autos ves.',
                    questionText: '',
                    questionImage: 'https://st2.depositphotos.com/2366719/7101/v/950/depositphotos_71017355-stock-illustration-simple-cars.jpg',
                    isMultipleAnswer: false,
                    options: [
                      {
                        option: 'Hay menos de 10',
                        optionImage: '',
                        isCorrect: false
                      },
                      {
                        option: 'Hay más de 10 y menos de 15',
                        optionImage: '',
                        isCorrect: false
                      },
                      {
                        option: 'Hay menos de 20 y más de 10',
                        optionImage: '',
                        isCorrect: true
                      }
                    ]
                  },
                  {
                    question: 'Lee el texto y selecciona las afirmaciones verdaderas.',
                    questionText: 'Las matemáticas o la matemática​ es una ciencia formal que, partiendo de axiomas y siguiendo el razonamiento lógico, estudia las propiedades, estructuras abstractas y relaciones entre entidades abstractas como números, figuras geométricas, iconos, glifos, o símbolos en general.',
                    questionImage: 'https://ichef.bbci.co.uk/news/800/cpsprodpb/164EE/production/_109347319_gettyimages-611195980.jpg',
                    isMultipleAnswer: true,
                    options: [
                      {
                        option: 'Las matemáticas son una ciencia',
                        optionImage: '',
                        isCorrect: true
                      },
                      {
                        option: 'La matemática estudia los números',
                        optionImage: '',
                        isCorrect: true
                      },
                      {
                        option: 'La matemática estudia las sustancias',
                        optionImage: '',
                        isCorrect: false
                      }
                    ]
                  },
                  {
                    question: 'Selecciona la afirmacion verdadera.',
                    questionText: '',
                    questionImage: '',
                    isMultipleAnswer: false,
                    options: [
                      {
                        option: 'Las matemáticas son una ciencia',
                        optionImage: '',
                        isCorrect: true
                      },
                      {
                        option: 'La matemática estudia los números',
                        optionImage: '',
                        isCorrect: true
                      },
                      {
                        option: 'La matemática estudia las figuras geométricas',
                        optionImage: '',
                        isCorrect: true
                      },
                      {
                        option: 'Todas las anteriores',
                        optionImage: '',
                        isCorrect: true
                      }
                    ]
                  },{
                    question: 'Selecciona la afirmacion verdadera.',
                    questionText: '',
                    questionImage: '',
                    isMultipleAnswer: false,
                    options: [
                      {
                        option: 'Las matemáticas son un invento',
                        optionImage: '',
                        isCorrect: false
                      },
                      {
                        option: 'La matemática estudia los animales',
                        optionImage: '',
                        isCorrect: false
                      },
                      {
                        option: 'La matemática estudia la biología',
                        optionImage: '',
                        isCorrect: false
                      },
                      {
                        option: 'Ninguna de las anteriores',
                        optionImage: '',
                        isCorrect: true
                      }
                    ]
                  }]"
                />
              </div>

            </tab-pane>-->
          </tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Auth from '../services/Auth';
import NProgress from 'nprogress';
import {Tabs, TabPane} from '../components';

export default {
  name: 'book',
  async created() {
    NProgress.done();
  },
  components: {
    Tabs,
    TabPane,
  },
  data () {
    return {
      firstExerciseAttempts: 0,
      firstExerciseValue: false,
      firstExerciseFractions: null,
    }
  },
  computed: {
    missionId () {
      return this.$route.params.missionId;
    }
  },
  methods: {
    logout() {
      Auth.logout();
    },
    goToMission() {
      this.$router.push(`/mission/${this.missionId}`);
    },
    onFirstExerciseEvaluated(config) {
      this.firstExerciseAttempts = this.firstExerciseAttempts + 1;
      this.firstExerciseValue = config.value;
      this.firstExerciseFractions = config.fractions;

      if (config.value) {
        alert(`Correcto a los ${this.firstExerciseAttempts} intentos con ${JSON.stringify(this.firstExerciseFractions)}`);
      } else {
        alert(`Incorrecto, ${this.firstExerciseAttempts} intentos`);
      }
    }
  },
}
</script>
<style lang="scss" scoped>

.spacecraft-container-glass {
  min-width: 100%;
  min-height: 100vh;
  max-height: 100vh;
  padding-top: 1rem !important;
  padding-bottom: 0rem;
  background-position: 50% 50%;
  background-image: url('/img/backgroundSpacecraft.png');
  background-size: cover;
  display: flex;
  align-items: center;
}

.mission-screen {
  border-style: solid;
  border-color: #17202A;
  border-width: 20px;
  border-radius: 50px;
  min-width: 93%;
  min-height: 95vh;
  margin: auto;
  padding-top: 0;
  padding-bottom: 0rem;
  padding-left: 2rem;
  background-image: url('/img/glass.png');
  background-size: cover;
}

.book {
  min-height: 80vh;
}

.page-header {
  overflow: auto;
}
</style>